import axios from "axios";
import { ContactMessage } from "../../api-types/contact";
import { CONTACT_URL } from "../utils";

export const addMessage = async (contactMessage: ContactMessage) => {
  return await axios.post(CONTACT_URL, contactMessage);
};
